export default __webpack_public_path__ + "static/media/access-health-information_290x170.563f161b.jpg";